export default __webpack_public_path__ + "static/media/480_dummy-2014-store01-de.54f5a036.png";